import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import {
  DELIVERY_FENCE_LAYER_STYLE,
  DELIVERY_FENCE_NAME_LAYER_STYLE,
  DELIVERY_FENCE_OUTLINE_LAYER_STYLE,
} from '../../../constants/map';
import { editSelectedDeliveryFenceState, selectedDeliveryFenceState } from '../../../storage/deliveryFences';

export function DeliveryFenceLayer() {
  const deliveryFence = useRecoilValue(selectedDeliveryFenceState);
  const editDeliveryFence = useRecoilValue(editSelectedDeliveryFenceState);

  if (!deliveryFence || !!editDeliveryFence) return null;

  const featureCollection: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: deliveryFence.polygon,
        properties: {
          name: deliveryFence.name,
        },
      },
    ],
  };

  return (
    <Source
      type="geojson"
      data={featureCollection}
      id="delivery-fence"
    >
      <Layer {...DELIVERY_FENCE_LAYER_STYLE} />
      <Layer {...DELIVERY_FENCE_OUTLINE_LAYER_STYLE} />
      <Layer {...DELIVERY_FENCE_NAME_LAYER_STYLE} />
    </Source>
  );
}
